
import { Model } from './_model';

export default class Participant extends Model {
  get defaults() {
    return {
      id: '',
      institutionName: '',
      role: '',
      allocation: [{
        id: '',
        securityIndex: '',
        amount: '',
        history: []
      }],
      securitySubscription: [],
      primaryContact: {
        lastName: '',
        firstName: '',
        middleInitial: ''
      },
      preferredSalutation: '',
      title: '',
      address: {
        street: '',
        districtOrTown: '',
        city: '',
        stateProvinceRegion: '',
        country: '',
        zipCode: ''
      },
      telephoneNumber: '',
      emailAddress: '',
      save: false,
      edit: false,
      isDeletable: true
    }
  }
}
